import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

type IAppFields = {
	businessSource?: string | null;
	resetState: () => void;
	setBusinessSource: (businessSource: string | null) => void;
};

const initialState = {
	businessSource: null
};

const useAppStore = create<IAppFields>()(
	persist(
		(set) => ({
			...initialState,
			resetState: () =>
				set({
					businessSource: null
				}),
			setBusinessSource: (businessSource) => {
				set({ businessSource });
			}
		}),
		{
			name: 'app-store',
			storage: createJSONStorage(() => globalThis.localStorage),
			partialize: (state) => state,
			version: 1
		}
	)
);

export default useAppStore;
